import React from "react";
import { Modal} from "antd";
import { URL_POND, URL_TANK, URL_TRUCK } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { dateTimeToHumanString, formatComma, toFixed } from "../../frameworks/Util";
import _ from "lodash";

export default function StorageTankWeightLogModal(props) {
  const { open, onClose, target } = props;
  const [ errorMessage, setErrorMessage ] = React.useState();
  const tableRef = React.useRef();
  const columns = [
    {
      title: 'วัน - เวลา',
      dataIndex: 'created',
      key: 'created',
      render : (value) => dateTimeToHumanString(value),
    },
    {
      title: 'น้ำหนัก',
      dataIndex: 'weight',
      key: 'weight',
      render : (value) => <center>{value ? formatComma(toFixed(value, 0)) : '-'}</center>
    },
    {
      title: 'หมายเหตุ',
      dataIndex: 'note',
      key: 'note',
    },
    {
      title: 'ผู้บันทึก',
      dataIndex: 'created_by_name',
      key: 'created_by_name',      
    },
  ]

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  React.useState(() => {
    if(target){
      refreshData();
    }
  },[target])

  React.useEffect(() => {
    setErrorMessage(null)
  },[open])

  return(
    <Modal
      title={<center>ประวัติเปลี่ยนน้ำหนัก</center>}
      open={open}
      onCancel={onClose}
      width={850}
      destroyOnClose
      footer={[
        <ColorButton onClick={onClose}>ปิด</ColorButton>
      ]}
    >
      <ErrorMessages message={errorMessage}/>
      {target && <TSTable
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_TANK.TANK_TRANSACTION_WEIGHT_LOG}
        params={{tank_transaction : target}}
      />}
    </Modal>
  )
}